(function (window) {
  'use strict';

  // Prices here are display-only. Shopify/Abra remain authoritative in the cart.
  var PROMOTION_ID = 'a8219a56-67a7-4974-9ad6-881c5ed2afd3';
  var suppressed = false;
  var signature = '';
  var boundaryTimer;
  var readinessTimer;

  function inWindow(value, now) {
    if (!value || value.status !== 'ACTIVE') return false;
    var start = value.startsAt ? Date.parse(value.startsAt) : null;
    var end = value.endsAt ? Date.parse(value.endsAt) : null;
    return (start === null || (Number.isFinite(start) && now >= start)) &&
      (end === null || (Number.isFinite(end) && now < end));
  }

  function currentPromotion(expectedId) {
    expectedId = expectedId || PROMOTION_ID;
    var abra = window.Abra;
    var promotion = abra && abra.publicPromotion;
    if (!abra || !abra.initialized || suppressed || !promotion || promotion.id !== expectedId) return null;
    if (!inWindow(promotion, Date.now())) return null;
    // The public metafield remains present after a promotion is unapplied.
    if (typeof abra.currentPromotionDetails === 'function') {
      var current;
      try { current = abra.currentPromotionDetails(); } catch (error) { return null; }
      if (!current || current.id !== expectedId) return null;
    }
    return promotion;
  }

  function variantMatches(values, variantId) {
    return Boolean(variantId && Array.isArray(values) && values.some(function (value) {
      return String(value).split('/').pop() === String(variantId).split('/').pop();
    }));
  }

  function targetsProduct(scope, input) {
    if (!scope) return false;
    return scope.all === true ||
      (Array.isArray(scope.products) && scope.products.indexOf(input.handle) !== -1) ||
      variantMatches(scope.variants, input.variantId) ||
      variantMatches(scope.productVariants && scope.productVariants[input.handle], input.variantId);
  }

  function unrestricted(discount) {
    var abra = window.Abra;
    var prerequisite = discount.prerequisite || {};
    var customer = prerequisite.customerSelection;
    var entitled = discount.entitled || {};
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || abra.currency;
    if (prerequisite.tapCartExclusive || prerequisite.posExclusive) return false;
    // This campaign has no customer or cart thresholds. Fail closed if that changes.
    if (customer && customer.type !== 'ALL') return false;
    if (prerequisite.minimumRequirement && Object.keys(prerequisite.minimumRequirement).some(function (key) {
      var value = prerequisite.minimumRequirement[key];
      return value != null && value !== false && value !== 0;
    })) return false;
    if (entitled.currency && entitled.currency !== currency) return false;
    var marketIds = entitled.shopifyMarketIds || [];
    var countries = entitled.markets || [];
    if (marketIds.length && marketIds.indexOf(abra.marketId) === -1) return false;
    if (countries.length && countries.indexOf(window.Shopify && window.Shopify.country) === -1) return false;
    return true;
  }

  function percentage(value, isMultiValue) {
    if (!value || value.type !== 'DiscountPercentage') return 0;
    var amount = Number(value.percentage);
    // Abra serializes normal percentage rewards as fractions, multi-value as percent.
    if (!isMultiValue && amount > 0 && amount <= 1) amount *= 100;
    return Number.isFinite(amount) && amount > 0 && amount <= 100 ? amount : 0;
  }

  function discountPercentage(discount, input, overview) {
    if (!inWindow(discount, Date.now()) || discount.discountClass !== 'PRODUCT' ||
        discount.appliesOnOneTimePurchase !== true || !unrestricted(discount)) return 0;
    if (!overview && !targetsProduct(discount.entitled, input)) return 0;
    var value = discount.discountValue || {};
    if (value.type === 'DiscountMultiValueCollection' || value.type === 'DiscountMultiValueProduct') {
      // entitled.all does not override these per-reward product/variant allowlists.
      return (value.productDiscounts || []).concat(value.variantDiscounts || []).reduce(function (best, reward) {
        return overview || targetsProduct(reward, input) ? Math.max(best, percentage(reward.value, true)) : best;
      }, 0);
    }
    return percentage(value, false);
  }

  function details(input, expectedId) {
    input = input || {};
    var original = Number(input.price);
    if (!Number.isFinite(original) || original < 0) original = 0;
    original = Math.round(original);
    var result = { active: false, percent: 0, title: '', originalPrice: original, price: original };
    if (input.sellingPlanId && String(input.sellingPlanId) !== '0') return result;
    var promotion = currentPromotion(expectedId);
    if (!promotion) return result;
    var overview = !input.handle && !input.variantId;
    var boundaries = [promotion.endsAt];
    var percent = Object.keys(promotion.discounts || {}).reduce(function (best, key) {
      var discount = promotion.discounts[key];
      var applicable = discountPercentage(discount, input, overview);
      if (applicable) boundaries.push(discount.endsAt);
      return Math.max(best, applicable);
    }, 0);
    if (!percent) return result;
    // Match Abra/Shopify: truncate the discount, not the final unit price.
    var discountCents = Math.floor(original * percent / 100 + 1e-8);
    var end = boundaries.map(Date.parse).filter(Number.isFinite).sort(function (a, b) { return a - b; })[0];
    return { active: true, percent: percent, title: promotion.title, originalPrice: original, price: original - discountCents, endsAt: end ? new Date(end).toISOString() : null };
  }

  function refresh() {
    var abra = window.Abra;
    var promotion = abra && abra.publicPromotion;
    var nextSignature = JSON.stringify({ active: Boolean(currentPromotion()), promotion: promotion });
    if (nextSignature !== signature) {
      signature = nextSignature;
      window.dispatchEvent(new CustomEvent('bcj:promotion:change'));
    }
    window.clearTimeout(boundaryTimer);
    if (promotion && promotion.id === PROMOTION_ID) {
      var now = Date.now();
      var times = [promotion.startsAt, promotion.endsAt];
      Object.keys(promotion.discounts || {}).forEach(function (key) {
        times.push(promotion.discounts[key].startsAt, promotion.discounts[key].endsAt);
      });
      var nextBoundary = times.map(Date.parse).filter(function (time) { return Number.isFinite(time) && time > now; }).sort(function (a, b) { return a - b; })[0];
      if (nextBoundary) boundaryTimer = window.setTimeout(refresh, Math.min(nextBoundary - now + 10, 2147483647));
    }
    if (abra && abra.initialized) window.clearInterval(readinessTimer);
  }

  window.BCJPromotion = {
    details: details,
    price: function (input) { return details(input).price; }
  };

  ['abra:initialized', 'abra:settled', 'abra:announced', 'abra:applied', 'abra:activated'].forEach(function (name) {
    window.addEventListener(name, function () { suppressed = false; refresh(); });
  });
  ['abra:deactivated', 'abra:unannounced', 'abra:unapplied'].forEach(function (name) {
    window.addEventListener(name, function () { suppressed = true; refresh(); });
  });
  window.addEventListener('pageshow', refresh);
  window.document.addEventListener('visibilitychange', refresh);
  readinessTimer = window.setInterval(refresh, 1000);
  refresh();
})(window);
